import { axiosInstance } from '.'
import { GET_PORTFOLIO_STATEMENTS, GET_PORTFOLIO_STATEMENT_DOWNLOAD } from './endpoints'

export type PortfolioStatement = {
  id: string
  investorId: number
  originalFilename: string
  label: string | null
  uploadedBy: number
  createdAt: string
}

export type ListPortfolioStatementsResponse = {
  statements: PortfolioStatement[]
}

export type DownloadPortfolioStatementResponse = {
  url: string
}

export const portfolioStatementsServices = {
  listMyStatements: async (headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.get<ListPortfolioStatementsResponse>(GET_PORTFOLIO_STATEMENTS, {
        headers,
      })
    } catch (error: any) {
      return error.response
    }
  },

  downloadStatement: async (id: string, headers: { [key: string]: string }) => {
    try {
      return await axiosInstance.get<DownloadPortfolioStatementResponse>(
        GET_PORTFOLIO_STATEMENT_DOWNLOAD(id),
        {
          headers,
        },
      )
    } catch (error: any) {
      return error.response
    }
  },
}
